import { WSPage } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { INVOICING_PATH } from "..";
import { useUrlQuery } from "../../../shared/hooks/useUrlQuery";
import { SearchPanel } from "../components/SearchPanel";
import { FilterableTableInvoices } from "../components/TableInvoices/FilterableTableInvoices";
import { InvoiceFilter } from "../components/TableInvoices/filters/types";

export const RouteSearch: React.FC = () => {
  const history = useHistory();
  const { urlQuery, setUrlQuery } = useUrlQuery<InvoiceFilter>();

  const search = urlQuery.filter?.search ?? "";

  const setSearch = (value: string) =>
    setUrlQuery(prev => ({
      ...prev,
      filter: { ...prev.filter, search: value || undefined }
    }));

  return (
    <WSPage>
      <SearchPanel
        mb="L"
        context="invoicing"
        onBack={() => {
          history.push(INVOICING_PATH);
        }}
        value={search}
        onSearch={setSearch}
        onClear={() => setSearch("")}
        placeholder="Search invoices"
      />

      {!!search && (
        <FilterableTableInvoices
          visibleFilters={{}}
          showDownloadCsv
          emptyState={{ standart: "No invoices match your search." }}
        />
      )}
    </WSPage>
  );
};
